import React from "react";
import { Typography } from "@mui/material";
import module from "./LoginContainer.module.css";

const LoginContainer = ({ label, children }) => {
  return (
    <div className={module.container}>
      <Typography variant="h1" sx={{ fontSize: "1.0rem" }}>
        {label}
      </Typography>
      <div className={module.contents}>{children}</div>
    </div>
  );
};

export default LoginContainer;
